import { FormConfig, FormValues, NextFunction } from '@topdanmark-onlinesolutions/claim-form-types';
import { getValueOrDefault } from '../../components/values/Get';

export const getNextPage: NextFunction = async (curPageId: string, formConfig: FormConfig, formValues: FormValues) => {
    let nextPage: string | undefined = '';

    switch (curPageId) {
        case 'godt-at-vide':
            nextPage = 'dato';
            break;
        case 'dato':
            nextPage = 'adresse';
            break;
        case 'adresse':
            nextPage = 'hvad-er-der-sket';
            break;
        case 'hvad-er-der-sket':
            nextPage = 'hvor-er-det-sket';
            break;
        case 'hvor-er-det-sket':
            nextPage = 'vandtilfoerslen';
            break;
        case 'vandtilfoerslen':
            nextPage = 'om-roerene';
            break;
        case 'om-roerene':
            nextPage = 'skadeservice';
            break;
        case 'skadeservice':
            nextPage = 'hvad-skyldes-skaden';
            break;
        case 'hvad-skyldes-skaden':
            if (
                getValueOrDefault(
                    formConfig,
                    formValues,
                    'menerduatskadenkanskyldesenfejlvedetproduktelleretstykkearbejdeduharfetudfrtfxhvisenhndvrkerharlavetenfejl'
                ).value === 'Ja'
            ) {
                nextPage = 'forbindelsen-til-skaden';
            } else {
                nextPage = 'eventuelle-kommentarer';
            }
            break;
        case 'forbindelsen-til-skaden':
            nextPage = 'eventuelle-kommentarer';
            break;
        case 'eventuelle-kommentarer':
            nextPage = 'dokumentation';
            break;
        case 'dokumentation':
            nextPage = 'virksomhedsoplysninger';
            break;
        case 'virksomhedsoplysninger':
            nextPage = 'forsikringsmaegler';
            break;
        case 'forsikringsmaegler':
            nextPage = 'andet-selskab';

            break;
        case 'andet-selskab':
            if (
                getValueOrDefault(formConfig, formValues, 'harduenforsikringietandetselskabsomdkkerdetsamme').value ===
                'Ja'
            ) {
                nextPage = 'hvilket-selskab';
            } else {
                nextPage = 'om-dig';
            }
            break;
        case 'hvilket-selskab':
            nextPage = 'om-dig';
            break;
        case 'om-dig':
            nextPage = 'resume';
            break;

        case 'resume':
            nextPage = undefined;
            break;

        default:
            throw new Error('Unknown page: ' + curPageId);
    }

    return nextPage;
};
